<template>
  <div class="block pt-3 pb-5 mb-8 border-b border-gray-200">
    <span class="text-lg leading-6 font-medium text-gray-900">
      <slot>
        <!-- Default Slot -->
      </slot>
    </span>
  </div>
</template>

<script>
export default {
  name: "SonicuHeader"
}
</script>

<style scoped>

</style>